<template>
    <button
        class="w-11 h-11 flex items-center justify-center rounded-full"
        :class="isStreaming ? stopClasses : sendClasses"
        @click="submit"
    >
        <StopIcon
            v-if="isStreaming"
            class="text-gray-180 dark:text-gray-190"
        />

        <ArrowUpIcon
            v-else
            :class="disabled ? 'text-gray-200' : 'text-white'"
        />
    </button>
</template>

<script setup>
import { computed } from 'vue'

import ArrowUpIcon from '@/components/ai/icons/ArrowUpIcon.vue'
import StopIcon from '@/components/ai/icons/StopIcon.vue'

const props = defineProps({
    isStreaming: {
        type: Boolean,
        default: false,
    },
    disabled: {
        type: Boolean,
        default: false,
    },
})

const emits = defineEmits(['send', 'stop'])

const sendClasses = computed(() => {
    if (props.disabled) {
        return 'bg-purple-60 dark:bg-black-370 dark:border-gray-730 border border-gray-100 dark:border-gray-730 cursor-not-allowed'
    }

    return 'bg-primary-gradient dark:bg-primary-gradient hover:bg-purple-500 dark:hover:bg-purple-300'
})

const stopClasses = 'bg-purple-60 dark:bg-black-370 border border-gray-100 dark:border-gray-730'

function submit() {
    if (props.isStreaming) {
        stop()
    } else {
        send()
    }
}

function send() {
    emits('send')
}

function stop() {
    emits('stop')
}
</script>
